
    import { initLeaderboard } from "/js/leaderboard.js";
    initLeaderboard();
  